<template>
    <div>
        <div class="pageHead">
            <div class="pageHead-search">
                <div class="flex_l_e">
                    <el-input class="pageHead-search-input" v-model="keyworld" maxlength="100" clearable
                              placeholder="请输入名称、关键词等" @keyup.enter.native="goToResourceList(1)"
                              @submit.native.prevent></el-input>
                    <el-button class="pageHead-search-btn" icon="el-icon-search" type="primary"
                               @click="goToResourceList()"></el-button>
                </div>
                <div class="flex_l_t pageHead-search-words">
                    <div>热词：</div>
                    <div class="flex_l_c recis flex_1">
                        <div @click="searchKeyWorld(item.label)" class="wordsItem"
                             v-for="item in $dictUtils.getDictList('hot_words')" :key="item.value">
                            {{ item.label }}
                        </div>
                    </div>
                </div>
                <div v-show="historyList.length" class="flex_b_c pageHead-search-words magTops">
                    <div class="flex_l_c flex_1">
                        <div>历史搜索：</div>
                        <div class="flex_l_c historyData">
                            <div @click="searchKeyWorld(item.name)"
                                 v-for="(item,index) in historyList"
                                 :key="index">
                                <el-tooltip class="item" effect="dark" :content="item.name"
                                            :disabled="item.newName ? false : true" placement="top">
                                    <div class="historyItem">
                                        {{ item.newName ? item.newName : item.name }}
                                        <i @click.stop="deleteHistory(item.name)" class="el-icon-close"></i>
                                    </div>
                                </el-tooltip>
                            </div>
                        </div>
                    </div>
                    <div class="historyClear" v-show="historyList.length" @click="deleteHistory()">一键清除<i
                            class="el-icon-delete"></i></div>
                </div>
            </div>
            <div class="pageHead-dataNum flex_b_c">
                <div class="flex_l_c dataNumItem">
                    <el-image
                            class="iconImg"
                            :src="require('@/assets/img/resourcesNum.png')"
                            fit="fill"></el-image>
                    <div class="dataNumCont">
                        <div>{{ resourcesNum }}</div>
                        <div class="dataNumContName">资源数</div>
                    </div>
                </div>
                <div class="flex_l_c dataNumItem">
                    <el-image
                            class="iconImg"
                            :src="require('@/assets/img/specialNum.png')"
                            fit="fill"></el-image>
                    <div class="dataNumCont">
                        <div>{{ numberOfTopics }}</div>
                        <div class="dataNumContName">专题数</div>
                    </div>
                </div>
                <div class="flex_l_c dataNumItem">
                    <el-image
                            class="iconImg"
                            :src="require('@/assets/img/fileNum.png')"
                            fit="fill"></el-image>
                    <div class="dataNumCont">
                        <div>{{ fileTotal }}</div>
                        <div class="dataNumContName">文件数</div>
                    </div>
                </div>
            </div>
        </div>
        <div class="pageContent">
            <div class="itemCont staple">
                <div class="flex_b_c">
                    <div class="itemCont-title">常用功能</div>
                    <div class="setUp" @click="setStaple()"></div>
                </div>
                <div class="stapleContent flex_l_c">
                    <div v-for="(item,index) in stapleList" :key="item.menuId" class="stapleContentItem flex_l_c"
                         @click="goToPage(item)">
                        <i v-show="item.icon" :class="[item.icon, `itemIcon${index%3}`]"></i>
                        <i v-show="!item.icon" :class="['iconfont','icon-yingyongmorentubiao', `itemIcon${index%3}`]"></i>
                        <el-tooltip class="item" effect="dark" :content="item.name" :disabled="!item.newName"
                                    placement="top-start">d
                            <span>{{ item.newName ? item.newName : item.name }}</span>
                        </el-tooltip>
                    </div>
                </div>
            </div>
            <div class="magTops flex_b_c">
                <div class="itemCont domainList">
                    <div class="itemCont-title">专题排行榜</div>
                    <div v-for="(item,index) in topicList" :key="index" class="domainListItem flex_b_c"
                         @click="searchKeyWorld(item.thematicName)">
                        <div class="flex_l_c">
                            <div v-show="index < 3"
                                 :class="['iconfont', index == 0 ? 'icon-redu1' : index == 1 ? 'icon-redu2' : 'icon-redu3', 'domainListItemIcon']"></div>
                            <div v-show="index >= 3" class="domainListItemIcon domainListItemNum">{{ index + 1 }}</div>
                            <el-tooltip class="item" effect="dark" :disabled="!item.disabled"
                                        :content="item.thematicName" placement="top">
                                <div :ref="'specialSubject' + index" class="domainListItemName omit">
                                    {{ item.thematicName }}
                                </div>
                            </el-tooltip>
                        </div>
                        <div class="domainListItemAfter">
                            <i v-show="index < 3" class="iconfont icon-huobao domainListItemAfterIcon"></i>
                            <span style="padding-right: .5rem">热度值</span>{{ item.resourcesNum }}
                        </div>
                    </div>
                </div>
                <div class="itemCont domainList">
                    <div class="itemCont-title">浏览量榜单</div>
                    <div v-for="(item,index) in pageViewList" :key="index" @click="seeData(item)" class="domainListItem flex_b_c">
                        <div class="flex_l_c">
                            <div v-show="index < 3"
                                 :class="['iconfont', index == 0 ? 'icon-redu1' : index == 1 ? 'icon-redu2' : 'icon-redu3', 'domainListItemIcon']"></div>
                            <div v-show="index >= 3" class="domainListItemIcon domainListItemNum">{{ index + 1 }}</div>
                            <el-tooltip class="item" effect="dark" :disabled="!item.disabled" :content="item.resourceName" placement="top">
                                <div :ref="'pageView' + index" class="domainListItemName omit">{{ item.resourceName }}</div>
                            </el-tooltip>
                        </div>
                        <div class="domainListItemAfter">
                            <i v-show="index < 3" class="iconfont icon-huobao domainListItemAfterIcon"></i>
                            <span style="padding-right: .5rem">浏览量</span>{{ item.pageView }}
                        </div>
                    </div>
                </div>
                <div class="itemCont dynamics">
                    <div class="flex_b_c">
                        <div class="itemCont-title">最新动态</div>
                        <div class="dynamicsMore">更多动态 <i class="el-icon-arrow-right"></i></div>
                    </div>
                    <div v-for="(item,index) in dynamicsList" :key="index"
                         :class="['dynamicsContItem', 'flex_b_t',index != 4 ? 'newB_b' : '']">
                        <div>
                            <div class="dynamicsContItemTitle">{{ item.title }}</div>
                            <el-tooltip class="item" effect="dark" :content="item.content" placement="top">
                                <div class="dynamicsContItemCont omit">{{ item.content }}</div>
                            </el-tooltip>
                        </div>
                        <el-image
                                class="dynamicsContItemImg"
                                :src="item.imgUrl"
                                :fit="'cover'"></el-image>
                    </div>
                </div>
            </div>
            <div class="itemCont newResources magTops">
                <div class="flex_b_c">
                    <div class="itemCont-title">最新资源</div>
                    <div class="dynamicsMore" @click="goToResourceList2()">查看更多 <i class="el-icon-arrow-right"></i>
                    </div>
                </div>
                <!--                <div class="flex_l_c magLefts">-->
                <!--                    <div :class="[-->
                <!--                        'resourcesType',-->
                <!--                        selectResourcesType == item.value ? 'selTypeClas' : '',-->
                <!--                        index + 1 == resourcesTypeList.length ? 'noMarginRight' : ''-->
                <!--                        ]" v-for="(item,index) in resourcesTypeList" :key="item.value"-->
                <!--                         @click="changeResourcesType(item)"-->
                <!--                    >-->
                <!--                        {{ item.label }}-->
                <!--                    </div>-->
                <!--                </div>-->
                <div class="newResourcesCont flex_l_c">
                    <div v-for="(item,index) in resourcesList" :key="index" :class="[
                            'newResourcesContItem',
                             (index != 0 && (index + 1) % 4 == 0) ? 'nomarginRight' :'',
                             ]">
                        <el-image
                                @click="seeData(item)"
                                class="newResourcesContImg"
                                :src="(item.jsonData.suoluetu && item.jsonData.suoluetu.length) ? item.jsonData.suoluetu[0].netUrl : ''"
                                :fit="'cover'">
                            <template slot="error" class="image-slot">
                                <el-image
                                        @click="seeData(item)"
                                        class="newResourcesContImg"
                                        :src="require('@/assets/img/default.png')"
                                        fit="fill">
                                </el-image>
                            </template>
                        </el-image>
                        <el-tooltip class="item" effect="dark" :disabled="!item.jsonData.newName"
                                    :content="item.jsonData.mingcheng"
                                    placement="top">
                            <div class="newResourcesContTitle">
                                {{ item.jsonData.newName ? item.jsonData.newName : item.jsonData.mingcheng }}
                            </div>
                        </el-tooltip>
                        <div class="flex_l_c newResourcesContBotm">
                            <div class="newResourcesContBton" @click="borrowing(item)">借阅</div>
                            <div v-if="item.isCollect != '0'" class="newResourcesContBton bton2"
                                 @click="collect(0,item)">收藏
                            </div>
                            <div v-else class="newResourcesContBton bton2" @click="collect(1,item)">取消收藏</div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <set-staple ref="setStapleDom" @refreshDataList="getMenu()"></set-staple>
        <add-borrowing ref="addBorrowing" @refresh="getDataList()"></add-borrowing>
    </div>
</template>

<script>
import SetStaple from "@/views/modules/academic/home/setStaple.vue";
import addBorrowing from "@/views/modules/academic/resourceList/addBorrowing.vue";

export default {
    name: "index",
    components: {addBorrowing, SetStaple},
    data() {
        return {
            keyworld: '',
            historyList: [],
            stapleList: [],//常用菜单

            numberOfTopics: '0',
            resourcesNum: '0',
            fileTotal: '0',
            topicList: [], //专题排行榜
            pageViewList: [], //浏览量榜单
            dynamicsList: [
                {
                    title: '随机森林模型参数寻优随机森林模型参数寻优',
                    content: '这是详细内容，已办摘取第一行这是详细内容，已办摘取第一行iu阿辉腐坏哦哦i哦就会',
                    imgUrl: 'https://img2.baidu.com/it/u=3674386755,3037847691&fm=253&fmt=auto&app=138&f=JPEG?w=956&h=500',
                },
                {
                    title: '随机森林模型参数寻优随机森林模型参数寻优',
                    content: '这是详细内容，已办摘取第一行这是详细内容，已办摘取第一行iu阿辉腐坏哦哦i哦就会',
                    imgUrl: 'https://img2.baidu.com/it/u=3674386755,3037847691&fm=253&fmt=auto&app=138&f=JPEG?w=956&h=500',
                },
                {
                    title: '随机森林模型参数寻优随机森林模型参数寻优',
                    content: '这是详细内容，已办摘取第一行这是详细内容，已办摘取第一行iu阿辉腐坏哦哦i哦就会',
                    imgUrl: 'https://img2.baidu.com/it/u=3674386755,3037847691&fm=253&fmt=auto&app=138&f=JPEG?w=956&h=500',
                },
                {
                    title: '随机森林模型参数寻优随机森林模型参数寻优',
                    content: '这是详细内容，已办摘取第一行这是详细内容，已办摘取第一行iu阿辉腐坏哦哦i哦就会',
                    imgUrl: 'https://img2.baidu.com/it/u=3674386755,3037847691&fm=253&fmt=auto&app=138&f=JPEG?w=956&h=500',
                },
                {
                    title: '随机森林模型参数寻优随机森林模型参数寻优',
                    content: '这是详细内容，已办摘取第一行这是详细内容，已办摘取第一行iu阿辉腐坏哦哦i哦就会',
                    imgUrl: 'https://img2.baidu.com/it/u=3674386755,3037847691&fm=253&fmt=auto&app=138&f=JPEG?w=956&h=500',
                },
            ], //最新动态

            selectResourcesType: '99',
            resourcesTypeList: [   //资源类型
                {
                    label: '全部资源',
                    value: 99,
                },
                {
                    label: '文物资源',
                    value: 1,
                },
                {
                    label: '图片资源',
                    value: 2,
                },
                {
                    label: '三维资源',
                    value: 3,
                },
                {
                    label: '音频资源',
                    value: 4,
                },
                {
                    label: '视频资源',
                    value: 5,
                },
                {
                    label: '附件资源',
                    value: 6,
                },
            ],
            resourcesList: [],
            seleListData: [], //借阅数据
        }
    },

    mounted() {
        this.getMenu()
        this.getDataList()
        this.getSpecialRankingList()
        this.getPageViewsRanking()
        this.getAllTotal()
        this.getHistory()
    },

    methods: {
        //获取总数
        getAllTotal() {
            //专题
            this.$axios(this.api.academic.thematicQueryTotal).then(data => {
                if (data && data.status) {
                    this.numberOfTopics = data.data
                }
            })
            this.$axios(this.api.metadata.metadataDataIndexQuantity, {}, 'post').then(data => {
                if (data && data.status) {
                    this.resourcesNum = data.data.resourceTotal
                    this.fileTotal = data.data.fileTotal
                }
            })
        },

        getHistory() {
            //历史记录
            this.$axios(this.api.metadata.selectMetadataDataHistoryIndex, {}, 'post').then(data => {
                if (data && data.status) {
                    this.historyList = data.data
                    this.historyList = this.historyList.map(item => {
                        let newName
                        if (item.length > 8) {
                            newName = item.slice(0, 8) + '...'
                        }
                        return {
                            name: item,
                            newName
                        }
                    })
                }
            })
        },

        //获取菜单
        getMenu() {
            this.$axios(this.api.user.sysmenucommonfunctionList).then(data => {
                if (data && data.status) {
                    this.stapleList = data.data
                    this.stapleList.forEach(item => {
                        if (item.name.length > 4) {
                            let newName = item.name.slice(0, 3)
                            this.$set(item, 'newName', newName + '...')
                        }
                    })
                }
            })
        },

        //点击常用菜单
        goToPage(row) {
            this.$router.push({path: row.href})
        },

        //获取最新资源
        getDataList() {
            this.$axios(this.api.metadata.selectMetadataDataIndex, {}, 'post').then(data => {
                if (data && data.status) {
                    this.resourcesList = data.data
                    this.resourcesList.forEach(item => {
                        if (item.jsonData.mingcheng.length > 18) {
                            let newName = item.jsonData.mingcheng.substring(0, 18)
                            this.$set(item.jsonData, 'newName', newName + '...')
                        }
                    })
                }
            })
        },

        //查看资源详情
        seeData(row) {
            this.$router.push({
                path: '/academic/resourceList/resourcesDetails',
                query: {id: row.metadataId || row.id, basicDataId: row.basicDataId}
            })
        },

        // type 0收藏 1取消收藏
        collect(type, row) {
            if (type == 0) {
                let dtos = [{
                    basicDataId: row.basicDataId,
                    metadataId: row.id,
                }]
                this.$axios(this.api.metadata.academicMyCollectionSave, dtos, 'post').then(data => {
                    if (data && data.status) {
                        this.$message.success('收藏成功')
                        this.getDataList()
                    } else {
                        this.$message.error(data.mag)
                    }
                })
            } else {
                this.$axios(this.api.metadata.academicMyCollectionUpdateByIds, [row.id], 'post').then(data => {
                    if (data && data.status) {
                        this.$message.success('取消收藏成功')
                        this.getDataList()
                    } else {
                        this.$message.error(data.mag)
                    }
                })
            }
        },

        //借阅
        borrowing(row) {
            this.$refs.addBorrowing.init([row])
        },

        //专题排行榜
        getSpecialRankingList() {
            this.$axios(this.api.academic.thematicQsueryRankingList).then(data => {
                if (data && data.status) {
                    this.topicList = data.data
                    this.$nextTick(() => {
                        this.topicList.forEach((item, index) => {
                            let disabled = this.overflowDom('specialSubject' + index)
                            this.$set(item, 'disabled', disabled)
                        })
                    })
                }
            })
        },

        //浏览量榜单
        getPageViewsRanking() {
            this.$axios(this.api.metadata.metadataDataPageViewList).then(data => {
                if (data && data.status) {
                    this.pageViewList = data.data
                    this.$nextTick(() => {
                        this.pageViewList.forEach((item, index) => {
                            let disabled = this.overflowDom('pageView' + index)
                            this.$set(item, 'disabled', disabled)
                        })
                    })
                }
            })
        },

        //点击历史搜索
        searchKeyWorld(item) {
            this.keyworld = item
            this.goToResourceList()
        },

        //去搜索结果页
        goToResourceList() {
            if (this.keyworld !== '') {
                this.$axios(this.api.metadata.addMetadataDataHistoryIndex, {keyword: this.keyworld}, 'get').then(data => {
                })
            }
            this.$router.push({
                path: '/academic/resourceList/resourceList',
                query: {keyworld: this.keyworld}
            })
        },

        goToResourceList2() {
            this.$router.push({
                path: '/academic/resourceList/resourceList',
            })
        },

        //删除历史搜索
        deleteHistory(item) {
            if (item) {
                //删一个
                this.$axios(this.api.metadata.delMetadataDataHistoryIndex, {keyword: item}, 'get').then(data => {
                    this.getHistory()
                })
            } else {
                //删所有
                this.$confirm(`确定清除所有历史记录？`, '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    this.$axios(this.api.metadata.delMetadataDataHistoryIndex, {}, 'get').then(data => {
                        this.getHistory()
                    })
                })
            }
        },

        //设置常用功能
        setStaple() {
            this.$refs.setStapleDom.init()
        },

        //选中资源类型
        changeResourcesType(row) {
            this.selectResourcesType = row.value
        },

        //判断dom的内容是否溢出 true溢出
        overflowDom(domName) {
            let configName = this.$refs[domName][0]
            if (configName.scrollWidth > configName.clientWidth) {
                return true
            } else {
                return false
            }
        },
    },
}
</script>

<style lang="scss" scoped>
.pageHead {
  position: relative;
  background-image: url("~@/assets/img/academicIndex.png");
  background-size: 100% 100%;
  width: 100%;
  height: 33.88vw;

  .pageHead-search {
    position: absolute;
    top: 25%;
    left: 50%;
    transform: translateX(-50%);

    .pageHead-search-input {
      width: 45vw;

      &::v-deep .el-input__inner {
        height: 4rem !important;
        line-height: 4rem !important;
        font-family: SourceHanSansCN-Normal;
        font-size: 1.13rem;
        padding-left: 1.88rem;
        border-radius: 0.5rem 0 0 0.5rem;
        border-width: .1rem;
      }
    }

    .pageHead-search-btn {
      padding: .8rem 1.6rem;
      margin-left: 0.13rem;
      text-align: center;
      height: 4.05rem !important;
      border-radius: 0 0.5rem 0.5rem 0;
      font-size: 1.75rem;
    }

    .pageHead-search-words {
      font-weight: 400;
      font-size: .98rem;
      font-family: SourceHanSansCN-Normal;
      color: #FFFFFF;
      margin-top: 1rem;
      opacity: .8;

      .recis {
        max-height: 9rem;
        overflow: hidden;
        flex-wrap: wrap;
      }

      .historyData {
        flex: 1;
        flex-wrap: wrap;
        height: 2.2rem;
        overflow: hidden;
      }

      .wordsItem {
        margin: 0 .8rem 0.3rem;
        cursor: pointer;
      }
    }

    .magTops {
      margin-top: 1.2rem;
    }

    .historyItem {
      padding: 0 0.75rem;
      margin: 0 0.4rem .4rem;
      font-size: 0.88rem;
      height: 2rem;
      line-height: 2rem;
      background: rgba(255, 255, 255, .2);
      border-radius: 1rem;
      cursor: pointer;

      i {
        margin-left: 0.1rem;
      }
    }

    .historyClear {
      width: 7rem;
      height: 2rem;
      text-align: center;
      line-height: 2rem;
      border-radius: 1rem;
      cursor: pointer;
      box-sizing: border-box;
      border: .1rem solid #FFFFFF;

      i {
        margin-left: 0.4rem;
      }
    }
  }

  .pageHead-dataNum {
    position: absolute;
    width: 60vw;
    bottom: 2rem;
    left: 50%;
    transform: translateX(-50%);

    .dataNumItem {
      width: 18.75rem;
      height: 9.38rem;
      padding: 2.4rem 2.8rem;
      background: rgba(255, 255, 255, .1);
      border-radius: 0.75rem;

      .iconImg {
        width: 4.5rem;
        height: 4.5rem;
      }

      .dataNumCont {
        margin-left: 2.5rem;
        font-size: 1.88rem;
        color: #FFFFFF;
        font-weight: 500;

        .dataNumContName {
          font-size: 1rem;
          font-weight: normal;
        }
      }
    }
  }
}

.pageContent {
  padding: 1.88rem 3.1rem;
  background: #EAE9E7;
  background-image: url("~@/assets/img/homeBackImg.png");
  background-size: 100% 100%;
  box-sizing: border-box;

  .magTops {
    margin-top: 1.25rem;
  }

  .itemCont {
    border-radius: 1rem;
    background: rgba(255, 255, 255, .5);

    .itemCont-title {
      position: relative;
      padding-left: 1.3rem;
      font-weight: 500;
      font-size: 1.38rem;
      color: #000000;

      &::before {
        content: '';
        position: absolute;
        left: 0;
        top: 50%;
        transform: translateY(-50%);
        width: 0.75rem;
        height: 1.25rem;
        background: url("~@/assets/img/decoration.png");
        background-size: 100% 100%;
      }
    }
  }

  .staple {
    padding: 1.63rem 1.25rem 2rem;

    .setUp {
      cursor: pointer;
      width: 1.75rem;
      height: 1.75rem;
      background-image: url("~@/assets/img/setting.png");
      background-size: 100% 100%;
    }

    .stapleContent {
      margin-top: 1.63rem;
      padding: 0 1.4rem 0 1.25rem;
      height: 4.5rem;
      flex-wrap: wrap;
      overflow: hidden;

      .stapleContentItem {
        cursor: pointer;
        margin-right: 1.4rem;
        margin-bottom: .2rem;
        flex-wrap: wrap;

        i {
          color: #C19558;
          font-size: 1.5rem;
          width: 2.25rem;
          height: 2.25rem;
          text-align: center;
          line-height: 2.25rem;
          border-radius: 0.5rem;
          background: rgba(230, 211, 184, .3);
          margin-right: 1.25rem;
        }

        .itemIcon1 {
          color: #80332D;
        }

        .itemIcon2 {
          color: #8E805F;
        }

        padding: 1rem 2.98rem;
        font-weight: 400;
        font-size: 1.13rem;
        color: #000000;
        background: #FFFFFF;
        border-radius: 0.75rem;
        border: .1rem solid #EEDFCA;
      }
    }
  }

  .domainList {
    width: 34.13rem;
    height: 36.62rem;
    margin-right: 1.25rem;
    padding: 2.3rem 1.25rem;

    .itemCont-title {
      margin-bottom: 0.63rem;
    }

    .domainListItem {
      cursor: pointer;
      margin-top: 1.25rem;
      font-size: 1.13rem;
      color: #010101;

      .domainListItemIcon {
        color: #EDCB3A;
        width: 1.75rem;
        height: 1.75rem;
        line-height: 1.75rem;
        font-size: 1.75rem;
        margin-right: 1.25rem;
      }

      .domainListItemName {
        width: 18rem;
      }

      .icon-redu2 {
        color: #ADADAD;
      }

      .icon-redu3 {
        color: #9E663F;
      }

      .domainListItemNum {
        text-align: center;
        font-weight: 500;
        font-size: 1.13rem;
        color: #010101;
      }

      .domainListItemAfter {
        font-size: 1rem;
        color: #4D4D4D;

        .domainListItemAfterIcon {
          font-size: 1rem;
          color: #C19558;
          margin-right: 0.63rem;
        }
      }
    }
  }

  .dynamics {
    width: 43rem;
    height: 36.62rem;
    padding: 2.25rem 1.25rem;

    .dynamicsMore {
      cursor: pointer;
      font-size: 1rem;
      color: #C19558;

      i {
        margin-left: 0.2rem;
      }
    }

    .dynamicsContItem {
      cursor: pointer;
      padding: 1.81rem 0 0.56rem 1.25rem;

      .dynamicsContItemTitle {
        font-weight: 400;
        font-size: 1.13rem;
        color: #000000;
      }

      .dynamicsContItemCont {
        margin-top: .5rem;
        width: 26rem;
        font-weight: 400;
        font-size: 0.88rem;
        color: #808080;
      }

      .dynamicsContItemImg {
        width: 6.25rem;
        height: 4.06rem;
        border-radius: 0.25rem;
      }
    }

    .newB_b {
      border-bottom: .1rem solid #EEEEEE;
    }
  }

  .newResources {
    padding: 2.25rem 1.25rem 1.56rem;

    .dynamicsMore {
      cursor: pointer;
      font-size: 1rem;
      color: #C19558;

      i {
        margin-left: 0.2rem;
      }
    }

    .magLefts {
      margin-left: 1.25rem;
    }

    .resourcesType {
      cursor: pointer;
      font-size: 1rem;
      color: #808080;
      width: 6.25rem;
      text-align: center;
      height: 2.38rem;
      line-height: 2.38rem;
      background: #FFFFFF;
      border-radius: 0.5rem;
      border: .1rem solid #CCCCCC;
      margin: 1.25rem 1.25rem 0 0;
    }

    .selTypeClas {
      color: #C19558;
      border-color: #C19558;
    }

    .noMarginRight {
      margin-right: 0;
    }

    .newResourcesCont {
      flex-wrap: wrap;

      .newResourcesContItem {
        margin-top: 1.94rem;
        width: 26.13rem;
        background: #FFFFFF;
        margin-right: 2.25rem;

        .newResourcesContImg {
          cursor: pointer;
          font-size: 0;
          width: 100%;
          height: 20.38rem;
        }

        .newResourcesContTitle {
          margin: .5rem 1.25rem 0;
          font-weight: bold;
          font-size: 1.25rem;
          color: #000000;
        }

        .newResourcesContBotm {
          margin: 1.2rem 1.25rem 2rem;

          .newResourcesContBton {
            cursor: pointer;
            width: 5.75rem;
            height: 2rem;
            text-align: center;
            line-height: 2rem;
            font-size: 1rem;
            color: #C19558;
            background-image: url("~@/assets/img/borrowing.png");
            background-size: 100% 100%;
          }

          .bton2 {
            margin-left: 1.56rem;
            color: #FFFFFF;
            background-image: url("~@/assets/img/collect.png");
          }
        }
      }

      .nomarginRight {
        margin-right: -1.8rem;
      }
    }
  }
}
</style>
